import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

const deleteBrollVideo = async (videoId: string) => {
  const res = await axiosInstance.delete('/api/video/delete/' + videoId);
  return res.data;
};

export const useDeleteBrollVideo = () => {
  return useMutation(deleteBrollVideo, { onSuccess: (data) => data });
};
